import { RECUPERAR_PAGAMENTOS_DESATIVADOS_USUARIO } from '../../actions/types'

const initialState = undefined
const estadoInicial = []

export default function reducerPagamentosDesativadosUsuario (state = estadoInicial, action = initialState) {
  switch (action.type) {
    case RECUPERAR_PAGAMENTOS_DESATIVADOS_USUARIO: {
      if (action.payload.data) {
        const pagamentosDesativadosUsuario = action.payload.data;
        return {
          ...state,
          pagamentosDesativadosUsuario
        }
      }
      return state
    }

    default: {
      return state
    }
  }
}
